// 文件作用于定义常量
export const GET_LIMIT = 'GET_LIMIT';
export const GET_FILTERLIST = 'GET_FILTERLIST';
export const GET_ALARMFILTERLIST = 'GET_ALARMFILTERLIST';
export const GET_WORKSHEETLIST = 'GET_WORKSHEETLIST';
export const GET_CUSTOMINFO = 'GET_CUSTOMINFO';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js